/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemForbidden } from './ProblemForbidden';

export const ForbiddenProblems: core.serialization.Schema<
    serializers.ForbiddenProblems.Raw,
    Truvity.ForbiddenProblems
> = core.serialization
    .union('type', {
        '/forbidden': ProblemForbidden,
    })
    .transform<Truvity.ForbiddenProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace ForbiddenProblems {
    export type Raw = ForbiddenProblems.Forbidden;

    export interface Forbidden extends ProblemForbidden.Raw {
        type: '/forbidden';
    }
}
